module.exports = __webpack_public_path__ + "img/slide1.67c31a2c.png";